import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();
const DEFAULT_LANGUAGE = "de";
const LANGUAGE_KEY = "scandicdev-language";

export const languages = {
  de: {
    code: "de",
    name: "Deutsch",
    flag: "DE",
  },
  en: {
    code: "en",
    name: "English",
    flag: "EN",
  },
};

export function LanguageProvider({ children, initialLanguage = DEFAULT_LANGUAGE }) {
  const safeInitialLanguage = languages[initialLanguage] ? initialLanguage : DEFAULT_LANGUAGE;
  const [language, setLanguage] = useState(safeInitialLanguage);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(LANGUAGE_KEY, language);
    }

    document.documentElement.lang = language;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
